import type { fastCleanGroupsError } from '../userQuotaCleaner.actions';
import type { QuotaCleanerState } from '../userQuotaCleaner.types';

export const fastCleanGroupsErrorReducer = (state: QuotaCleanerState, action: ReturnType<typeof fastCleanGroupsError>) => ({
    ...state,
    fastCleanState: {
        ...state.fastCleanState,
        fastCleanGroups: state.fastCleanState.fastCleanGroups.map((group) => {
            if (action.payload.includes(group.groupId)) {
                return {
                    ...group,
                    cleaningState: {
                        isCleanLoading: false,
                        isCleanLoaded: true,
                        isCleanSuccess: false,
                        isCleanError: true,
                    },
                };
            }

            return group;
        }),
    },
});
